import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';
import type { EntsDrawer } from '../drawer/drawer.js';

const templateElement = document.getElementById('certificate-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  setup() {
    const drawer = ref<EntsDrawer | null>(null);
    const certifiedColumn = ref<unknown[]>([]);

    onMounted(() => {
      EventBus.on('ents:vue:certificate:drawer:open', (column: unknown[]) => {
        certifiedColumn.value = column;
        openCertificateDrawer();
      });
    });

    onUnmounted(() => {
      EventBus.off('ents:vue:certificate:drawer:open', openCertificateDrawer);
    });

    const openCertificateDrawer = async () => {
      await import('../drawer/drawer.js');
      (drawer.value as EntsDrawer).show();
    };

    return {
      drawer,
      certifiedColumn,
    };
  },
});
